// src/app/features/helpLoan/useHelpLoan.js
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createHelpLoanApplication,
  getMyHelpLoanApplications,
  presignHelpLoanUpload,
  uploadToPresignedUrl,
} from "./helpLoanApi.js";

export function useMyHelpLoanApplications(params = {}) {
  return useQuery({
    queryKey: ["helpLoanApplications", params],
    queryFn: () => getMyHelpLoanApplications(params),
  });
}

export function usePresignHelpLoanUpload() {
  return useMutation({
    mutationFn: presignHelpLoanUpload,
  });
}

export function useUploadToS3() {
  return useMutation({
    mutationFn: ({ uploadUrl, file }) => uploadToPresignedUrl(uploadUrl, file),
  });
}

export function useCreateHelpLoanApplication() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createHelpLoanApplication,
    onSuccess: async () => {
      await qc.invalidateQueries({ queryKey: ["helpLoanApplications"] });
    },
  });
}
